<script setup lang="ts">
/**
 * Final Dividends — Notification of Resolution Passed (Sole Corporate Member).
 *   원본: Notification of Resolution Passed – Final Dividends (Sole Corporate Member).
 *   서명 = 이사 1인([[Signing_Director_Signature]]).
 */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
      <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
    </div>

    <p class="doc-p">Date: <CddVarField field-key="letter_date" label="Letter Date" /></p>
    <p class="doc-p">
      <CddVarField field-key="member_name" label="Member Name" /><br />
      <CddVarField field-key="member_address" label="Member Address" />
    </p>
    <p class="doc-p">Dear Sirs</p>
    <p class="doc-p"><b><CddVarField field-key="company_name" label="Company Name" /> (the &ldquo;Company&rdquo;)</b><br />- Member&rsquo;s Resolutions In Writing</p>

    <p class="doc-p">
      We are writing to notify you that the member&rsquo;s resolutions in writing of the Company relating the deemed extraordinary general
      meeting were passed on <CddVarField field-key="resolution_passed_date" label="Resolution Passed Date" />.
    </p>

    <p class="doc-p">Yours faithfully</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>
  </div>
</template>
